import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Row, Col, Label } from 'reactstrap';
import Constants from '../../../Constants';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;

class TypeaheadInput extends React.Component {
  onChange = (inputFields, value) => {
    let holder = '';
    if (value.length !== 0) {
      holder = value[0].id;
    }
    this.props.onInputChange(inputFields, holder);
  };
  render() {
    const inputFields = this.props;
    const minLength = 1;
    const placeholder = `Choose an ${inputFields.title} ...`;

    if (inputFields.change) {
      this.typeahead.getInstance().clear();
    }

    const { required } = this.props;

    const controlSize = layoutGridSize - formLabelSize;
    const controlSizeSm = layoutGridSize - formLabelSizeSm;

    const errorClass = this.props.errorMessages ? 'border-error' : '';
    const error = this.props.errorMessages;

    return (
      <div ref={inputFields.refProps} className="pTop-5 type-ahead">
        <Row className="lsn-form-label-control relative">
          <Label
            className="lsn-form-label ScalaSansOT mTop-6"
            for={`${this.props.id}_input_id`}
            sm={formLabelSizeSm}
            md={formLabelSize}>
            {required ? <span className="lsn-red">*</span> : void 0}
            {inputFields.title}
          </Label>
          <Col className={`input-left relative col-sm-${controlSizeSm} col-md-${controlSize}`}>
            {inputFields.defaultIndex !== null && (
              <Typeahead
                id={this.props.id}
                inputProps={{
                  id: `${this.props.id}_input_id`,
                }}
                ref={(typeahead) => (this.typeahead = typeahead)}
                defaultSelected={inputFields.dataObj.slice(inputFields.defaultIndex, inputFields.defaultIndex + 1)}
                className={' ' + errorClass}
                disabled={this.props.disabled}
                labelKey={this.props.labelKey}
                highlightOnlyResult={false}
                minLength={minLength}
                options={inputFields.dataObj}
                placeholder={placeholder}
                onChange={(evt) => this.onChange(inputFields, evt)}
                onInputChange={(evt) => this.onChange(inputFields, evt)}
              />
            )}
            {inputFields.defaultIndex === null && (
              <Typeahead
                id={this.props.id}
                inputProps={{
                  id: `${this.props.id}_input_id`,
                }}
                ref={(typeahead) => (this.typeahead = typeahead)}
                className={' ' + errorClass}
                labelKey={this.props.labelKey}
                highlightOnlyResult={false}
                minLength={minLength}
                options={inputFields.dataObj}
                placeholder={placeholder}
                onChange={(evt) => this.onChange(inputFields, evt)}
                onInputChange={(evt) => this.onChange(inputFields, evt)}
              />
            )}
            <div className="height-25 v-align-top">
              <span
                hidden={!error}
                className="input-error"
                role="alert">{`${inputFields.title} can not be empty`}</span>
            </div>
          </Col>
          <span className={'search-icon ' + (inputFields.searchClick ? '' : '')}>
            <i className="fa fa-search"></i>
          </span>
        </Row>
      </div>
    );
  }
}

export default TypeaheadInput;
